const autoNgTemplateLoaderTemplate1 = require('./docker-features-configuration.html');

import angular from 'angular';

import controller from './docker-features-configuration.controller';

angular.module('shbdeployer.docker').component('dockerFeaturesConfigurationView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
  bindings: {
    endpoint: '<',
  },
});
